var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComputerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eos-icons:software"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36.9318 45.272C34.6513 44.1649 32.6927 42.4872 31.2445 40.4H13.9318V15.2H51.5682V19.946C53.2601 21.1419 54.6845 22.6798 55.75 24.461V15.2C55.75 14.0861 55.3094 13.0178 54.5252 12.2302C53.7409 11.4425 52.6773 11 51.5682 11H13.9318C12.8227 11 11.7591 11.4425 10.9748 12.2302C10.1906 13.0178 9.75 14.0861 9.75 15.2V40.4C9.75 41.5139 10.1906 42.5822 10.9748 43.3698C11.7591 44.1575 12.8227 44.6 13.9318 44.6H28.5682V48.8H24.3864V53H41.1136V48.8H36.9318V45.272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M42.75 20C40.1788 20 37.6654 20.7331 35.5276 22.1066C33.3898 23.4801 31.7235 25.4324 30.7396 27.7165C29.7556 30.0005 29.4982 32.5139 29.9998 34.9386C30.5014 37.3634 31.7395 39.5907 33.5576 41.3388C35.3757 43.087 37.6921 44.2775 40.2138 44.7598C42.7356 45.2421 45.3494 44.9946 47.7249 44.0485C50.1003 43.1024 52.1306 41.5002 53.5591 39.4446C54.9876 37.389 55.75 34.9723 55.75 32.5C55.75 29.1848 54.3804 26.0054 51.9424 23.6612C49.5044 21.317 46.1978 20 42.75 20ZM42.75 35.625C42.1072 35.625 41.4789 35.4417 40.9444 35.0983C40.4099 34.755 39.9934 34.2669 39.7474 33.6959C39.5014 33.1249 39.437 32.4965 39.5625 31.8903C39.6879 31.2841 39.9974 30.7273 40.4519 30.2903C40.9064 29.8532 41.4855 29.5556 42.116 29.435C42.7464 29.3145 43.3999 29.3763 43.9937 29.6129C44.5876 29.8494 45.0952 30.2499 45.4523 30.7638C45.8094 31.2777 46 31.8819 46 32.5C46 33.3288 45.6576 34.1237 45.0481 34.7097C44.4386 35.2958 43.612 35.625 42.75 35.625Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputerIcon);
export default __webpack_public_path__ + "static/media/computerIcon.207d56f4611bce8da61bd04ce375098a.svg";
export { ForwardRef as ReactComponent };